/**
 * Utility functions for handling confirmation token presence during tenant registration
 */

/**
 * Check if the confirmation token is present in cookies
 * @param {object} cookies - Vue cookies instance (this.$cookies)
 * @returns {boolean} - true if confirmation token is present
 */
export function isConfirmTokenPresent (cookies) {
  const confirmToken = cookies.get('is_confirm_token_present')
  return !!confirmToken
}

/**
 * Show session expired warning toast (for page load warnings)
 * @param {object} vm - Vue component instance (this)
 */
export function showSessionExpiredWarning (vm) {
  vm.$snotify.warning(
    'Sign-up session expired. Please reopen the link in your email to start over.',
    'Session Expired',
    { ...vm.$store.state.snotify }
  )
}
